import { Icon, IconProps } from './Icon';

interface DeleteIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const DeleteIcon = ({ color = '#C8102E', gradient, ...props }: DeleteIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      d="M18 6.53027H19"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M9 10.4697V16.5297"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12 9.30957V17.5796"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M15 10.4697V16.5297"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.795 20.4723H8.205C6.987 20.4723 6 19.4853 6 18.2673V6.52832H18V18.2673C18 19.4853 17.013 20.4723 15.795 20.4723Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M16 6.52832L15.262 4.22332C15.129 3.80932 14.744 3.52832 14.31 3.52832H9.69C9.255 3.52832 8.87 3.80932 8.738 4.22332L8 6.52832"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5 6.53027H6"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
